import * as React from 'react';
import { Table } from 'semantic-ui-react';

// Global Components
// @ts-ignore
import EntityTypeName from 'components/EntityTypeName';
// @ts-ignore
import ResponsiveTable from 'components/ResponsiveTable';

// Child Components
import RenderEntityTableRows from './components/RenderEntityTableRows';

interface Props {
    entityTypeId: number;
}

export default function RenderSectorTable(props: Props): React.ReactElement {
    const { entityTypeId } = props;

    return (
        <ResponsiveTable>
            <Table sortable striped singleLine unstackable size="small">
                <Table.Header
                    style={{
                        fontSize: 14
                    }}
                >
                    <Table.Row>
                        <Table.HeaderCell className="events-table-cell-padding">
                            <EntityTypeName entityTypeId={entityTypeId} />
                        </Table.HeaderCell>

                        <Table.HeaderCell
                            className="events-table-cell-padding"
                            textAlign="center"
                        >
                            via email
                        </Table.HeaderCell>

                        <Table.HeaderCell
                            className="events-table-cell-padding"
                            textAlign="center"
                        >
                            via text message
                        </Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    <RenderEntityTableRows />
                </Table.Body>
            </Table>
        </ResponsiveTable>
    );
}
